import * as yup from "yup";
import i18n from "core/i18n";

export default function getValidationSchema() {
    const { t } = i18n.useTranslation();

    return yup
        .object({
            consentGiven: yup.boolean().oneOf([true], t("error.required")).required(t("error.required")),
            operationType: yup.string().required(t("error.required")),
        })
        .required();
}
